.loaderContainer {
  display: flex;
  min-width: 91px;
  justify-content: center;
  align-items: center;
}